import { RadioGroup } from "@portal/BaseComponents/Radio/AntRadio";
import { GenericRadioChangeEvent } from "@portal/BaseComponents/Radio/types";
import { disputeFiltersAtom } from "@portal/store/Filters/dipsutes/dispute-filter";
import { disputeViewOptions } from "@portal/store/Filters/dipsutes/predicate";
import { resetPage, tableAtom } from "@portal/store/table/table";
import { DisputeViews } from "@portal/types/entities/dispute";
import produce from "immer";
import { useAtom, useSetAtom } from "jotai";

function DisputeStatusFilter() {
  const [disputeFilters, setDisputeFilters] = useAtom(disputeFiltersAtom);
  const setTable = useSetAtom(tableAtom);
  function onChange(event: GenericRadioChangeEvent<DisputeViews>) {
    setDisputeFilters((filter) => {
      return produce(filter, (draft) => {
        draft.filterValues.view = event.target.value;
      });
    });
    setTable(resetPage);
  }
  return (
    <RadioGroup
      optionType="button"
      options={disputeViewOptions}
      buttonStyle="solid"
      defaultValue={disputeFilters.filterValues.view ?? "ALL"}
      onChange={onChange}
    />
  );
}

export { DisputeStatusFilter };
